module.exports = __webpack_public_path__ + "img/classic@2x.7bd978f.webp";